import React from 'react';
import ChatSend from '@bit/super-mario.yoshi.chatsend';
import './bottom.css';

const ChatBottom = ({ chatToken, channelId, threadId }) => (
  <div className='chat-bottom-container'>
    <div className='left-menu'>
      <figure>
        <img src='/icons/icons8-image-100.png' width="36" />
      </figure>
    </div>
    <div className='chat-message'>
      <ChatSend chatToken={chatToken} channelId={channelId} threadId={threadId} />
    </div>
  </div>
);

export default ChatBottom;